/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const RenrenIconConfig = {
  name: 'RenrenIcon',
  height: 512,
  width: 512,
  svgPath: 'M214 169.1c0 110.4-61 205.4-147.6 247.4C30 373.2 8 317.7 8 256.6 8 133.9 97.1 32.2 214 12.5v156.6zM255 504c-42.9 0-83.3-11-118.5-30.4C193.7 437.5 239.9 382.9 255 319c15.5 63.9 61.7 118.5 118.8 154.7C338.7 493 298.3 504 255 504zm190.6-87.5C359 374.5 298 279.6 298 169.1V12.5c116.9 19.7 206 121.4 206 244.1 0 61.1-22 116.6-58.4 159.9z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(RenrenIconConfig);